(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9925],{

/***/ 37335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/utils/alternate-url.ts
var alternate_url = __webpack_require__(50146);
;// CONCATENATED MODULE: ./src/components/Abstracts/Breadcrumb/serialize-json-ld.ts

function serializeJSONLD(param) {
    var links = param.links;
    return {
        itemListElements: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
            return {
                position: "".concat(index + 1),
                name: link === null || link === void 0 ? void 0 : link.children,
                item: (link === null || link === void 0 ? void 0 : link.href) ? (0,alternate_url/* default */.Z)(link.href) : ""
            };
        })
    };
}

// EXTERNAL MODULE: ./src/components/Abstracts/Breadcrumb/styles.module.scss
var styles_module = __webpack_require__(11216);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Breadcrumb/index.tsx









var cx = bind_default().bind((styles_module_default()));
function Breadcrumb(param) {
    var className = param.className, separatorClassName = param.separatorClassName, separatorItem = param.separatorItem, linkClassName = param.linkClassName, activeClassName = param.activeClassName, itemClassName = param.itemClassName, noLinkClassName = param.noLinkClassName, links = param.links;
    var t = (0,lib/* useTranslate */.qM)();
    var linksWithTrad = links === null || links === void 0 ? void 0 : links.map(function(link) {
        var ref, ref1;
        var isTradKey = typeof (link === null || link === void 0 ? void 0 : link.children) === "string" && (link === null || link === void 0 ? void 0 : (ref = link.children) === null || ref === void 0 ? void 0 : ref.includes("."));
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
            children: isTradKey ? typeof (link === null || link === void 0 ? void 0 : link.children) === "string" && t(link === null || link === void 0 ? void 0 : (ref1 = link.children) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) : link === null || link === void 0 ? void 0 : link.children
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, (0,_object_spread/* default */.Z)({}, serializeJSONLD({
                links: links
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).Breadcrumb,
                children: linksWithTrad === null || linksWithTrad === void 0 ? void 0 : linksWithTrad.map(function(link, index) {
                    var isActive = index === links.length - 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx((styles_module_default()).item, itemClassName, isActive ? activeClassName : null),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
                                className: cx((link === null || link === void 0 ? void 0 : link.href) ? null : ((styles_module_default()).noLink, noLinkClassName !== null && noLinkClassName !== void 0 ? noLinkClassName : null), (styles_module_default()).link, linkClassName)
                            }, link)),
                            index + 1 !== (links === null || links === void 0 ? void 0 : links.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: separatorClassName,
                                children: separatorItem !== null && separatorItem !== void 0 ? separatorItem : "/"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
Breadcrumb.defaultProps = {};
/* harmony default export */ var Abstracts_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./src/providers/BreadcrumbProvider/index.tsx
var BreadcrumbProvider = __webpack_require__(82082);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/Breadcrumb/styles.module.scss
var Breadcrumb_styles_module = __webpack_require__(15028);
var Breadcrumb_styles_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumb_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Breadcrumb/index.tsx











var Breadcrumb_cx = bind_default().bind((Breadcrumb_styles_module_default()));
function Breadcrumb_Breadcrumb(_param) {
    var className = _param.className, textPreset = _param.textPreset, textStyling = _param.textStyling, color = _param.color, theme = _param.theme, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "textPreset",
        "textStyling",
        "color",
        "theme"
    ]);
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        color: color !== null && color !== void 0 ? color : colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: textPreset !== null && textPreset !== void 0 ? textPreset : text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        textStyling: textStyling !== null && textStyling !== void 0 ? textStyling : text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var links = (0,BreadcrumbProvider/* useBreadCrumb */.dp)().links;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Breadcrumb, (0,_object_spread/* default */.Z)({
        links: links,
        className: Breadcrumb_cx((Breadcrumb_styles_module_default()).Breadcrumb, textStyle, className, (Breadcrumb_styles_module_default()) === null || (Breadcrumb_styles_module_default()) === void 0 ? void 0 : (Breadcrumb_styles_module_default())["theme-".concat(theme)]),
        linkClassName: Breadcrumb_cx((Breadcrumb_styles_module_default()).link, textStyle),
        itemClassName: (Breadcrumb_styles_module_default()).item,
        activeClassName: (Breadcrumb_styles_module_default()).active,
        separatorClassName: (Breadcrumb_styles_module_default()).separator,
        noLinkClassName: (Breadcrumb_styles_module_default()).noLink,
        separatorItem: "•"
    }, rest));
}
Breadcrumb_Breadcrumb.defaultProps = {
    theme: "footer"
};
/* harmony default export */ var UI_Breadcrumb = (Breadcrumb_Breadcrumb);


/***/ }),

/***/ 5266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14408);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13200);
/* harmony import */ var _components_UI_LogoTypes_logo_illu_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88334);
/* harmony import */ var _hooks_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66794);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72933);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);











var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
function FooterLogo(param) {
    var className = param.className, theme = param.theme, hasNoLink = param.hasNoLink;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var locale = (0,_hooks_useLocale__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var linkProps = {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().FooterLogo), className),
        title: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_6__/* .GENERAL.LOGO_TITLE */ .vh.LOGO_TITLE),
        href: "/".concat(locale)
    };
    return hasNoLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: linkProps.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_LogoTypes_logo_illu_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logo), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()) === null || (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()) === void 0 ? void 0 : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["theme-".concat(theme)])
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_LogoTypes_logo_illu_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logo), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()) === null || (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()) === void 0 ? void 0 : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["theme-".concat(theme)])
        })
    }));
}
FooterLogo.defaultProps = {
    hasNoLink: false
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterLogo);


/***/ }),

/***/ 69925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UI_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/UI/Breadcrumb/index.tsx + 2 modules
var Breadcrumb = __webpack_require__(37335);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Abstracts/PopIn/index.tsx
var PopIn = __webpack_require__(32671);
// EXTERNAL MODULE: ./src/components/Popins/ContactPopin/index.tsx + 4 modules
var ContactPopin = __webpack_require__(41709);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/providers/PopInProvider/index.tsx
var PopInProvider = __webpack_require__(18286);
// EXTERNAL MODULE: ./src/components/UI/Footer/FooterColumn/styles.module.scss
var styles_module = __webpack_require__(40466);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Footer/FooterColumn/index.tsx












var cx = bind_default().bind((styles_module_default()));
function FooterColumn(param) {
    var className = param.className, links = param.links, textThemes = param.textThemes;
    var ref = (0,PopInProvider/* usePopIn */.wG)(), addPopin = ref.add;
    var hasLinks = (links === null || links === void 0 ? void 0 : links.length) > 0;
    var onClickItem = function(e) {
        e.preventDefault();
        addPopin(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopIn/* default */.ZP, {
            className: cx((styles_module_default()).popin),
            isCloseButton: true,
            closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
                className: (styles_module_default()).popinClose
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopin/* default */.Z, {
                className: cx((styles_module_default()).contactPopin)
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).FooterColumn, className),
        children: hasLinks && (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cx((styles_module_default()).items),
            children: links.map(function(item, key) {
                var isContactLink = item.isContactLink, rest = (0,_object_without_properties/* default */.Z)(item, [
                    "isContactLink"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                    textPreset: text_preset/* GlobalTextPreset.Cta10_12GroteskRegular */.C.Cta10_12GroteskRegular,
                    textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                    theme: textThemes.dilutedLink,
                    className: cx((styles_module_default()).link),
                    lineProps: {
                        initialLineState: "none"
                    },
                    onClick: (item === null || item === void 0 ? void 0 : item.isContactLink) ? function(e) {
                        onClickItem(e);
                    } : null
                }, rest), "link_".concat(key));
            })
        })
    });
}
FooterColumn.defaultProps = {};
/* harmony default export */ var Footer_FooterColumn = (FooterColumn);

// EXTERNAL MODULE: ./src/components/UI/Footer/FooterLogo/index.tsx
var FooterLogo = __webpack_require__(5266);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/index.js
var Accordion = __webpack_require__(99385);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/AccordionPanel/index.js
var AccordionPanel = __webpack_require__(4903);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/Footer/FooterMobileColumns/styles.module.scss
var FooterMobileColumns_styles_module = __webpack_require__(59553);
var FooterMobileColumns_styles_module_default = /*#__PURE__*/__webpack_require__.n(FooterMobileColumns_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Footer/FooterMobileColumns/index.tsx














var FooterMobileColumns_cx = bind_default().bind((FooterMobileColumns_styles_module_default()));
function FooterMobileColumns(param) {
    var className = param.className, columns = param.columns, textThemes = param.textThemes, theme = param.theme;
    var ref = (0,PopInProvider/* usePopIn */.wG)(), addPopin = ref.add;
    var panelHeadStyle = (0,StyleProvider/* useStyle */.X)({
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        textPreset: text_preset/* GlobalTextPreset.Cta16Grotesk */.C.Cta16Grotesk
    });
    var triggerStyle = (0,StyleProvider/* useStyle */.X)({
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk
    });
    var panelBodyStyle = (0,StyleProvider/* useStyle */.X)({
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var onClickItem = function(e) {
        e.preventDefault();
        addPopin(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopIn/* default */.ZP, {
            className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).popin),
            isCloseButton: true,
            closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
                className: (FooterMobileColumns_styles_module_default()).popinClose
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopin/* default */.Z, {
                className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).contactPopin)
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).FooterMobileColumns, className, (FooterMobileColumns_styles_module_default()) === null || (FooterMobileColumns_styles_module_default()) === void 0 ? void 0 : (FooterMobileColumns_styles_module_default())["theme-".concat(theme)]),
        children: (columns === null || columns === void 0 ? void 0 : columns.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.UQ, {
            children: columns === null || columns === void 0 ? void 0 : columns.map(function(param, key) {
                var mobileTitle = param.mobileTitle, links = param.links;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AccordionPanel/* AccordionPanel */.H, {
                    className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).panel),
                    index: key,
                    head: function(isActive) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).panelHead, {
                                isActive: isActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).title, panelHeadStyle),
                                    children: mobileTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).state, triggerStyle),
                                    children: isActive ? "(—)" : "(+)"
                                })
                            ]
                        });
                    },
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).panelBody),
                        children: (links === null || links === void 0 ? void 0 : links.length) > 0 && (links === null || links === void 0 ? void 0 : links.map(function(item, key) {
                            var isContactLink = item.isContactLink, rest = (0,_object_without_properties/* default */.Z)(item, [
                                "isContactLink"
                            ]);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).item, panelBodyStyle),
                                children: item && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: FooterMobileColumns_cx((FooterMobileColumns_styles_module_default()).linkContainer),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: (FooterMobileColumns_styles_module_default()).link,
                                        theme: textThemes.dilutedLink,
                                        textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
                                        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                        lineProps: {
                                            initialLineState: "none"
                                        },
                                        onClick: (item === null || item === void 0 ? void 0 : item.isContactLink) ? function(e) {
                                            onClickItem(e);
                                        } : null
                                    }, rest))
                                })
                            }, "link_mobile_".concat(key));
                        }))
                    })
                }, "panel_".concat(key));
            })
        })
    });
}
FooterMobileColumns.defaultProps = {};
/* harmony default export */ var Footer_FooterMobileColumns = (FooterMobileColumns);

// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/providers/GlobalDataProvider/index.tsx
var GlobalDataProvider = __webpack_require__(11036);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/Footer/styles.module.scss
var Footer_styles_module = __webpack_require__(50252);
var Footer_styles_module_default = /*#__PURE__*/__webpack_require__.n(Footer_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Footer/index.tsx





















var Footer_cx = bind_default().bind((Footer_styles_module_default()));
function getTextColorsFromTheme(theme) {
    switch(theme){
        case colors/* GlobalThemeColors.Black */.b.Black:
            return {
                dilutedLink: colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice,
                breadcrumbTheme: colors/* GlobalThemeColors.White */.b.White
            };
        case colors/* GlobalThemeColors.William */.b.William:
        case colors/* GlobalThemeColors.Eunry */.b.Eunry:
        case colors/* GlobalThemeColors.IrishCoffee */.b.IrishCoffee:
            return {
                dilutedLink: colors/* GlobalThemeColors.Concrete */.b.Concrete,
                breadcrumbTheme: colors/* GlobalThemeColors.Concrete */.b.Concrete
            };
        case colors/* GlobalThemeColors.Amber */.b.Amber:
            return {
                dilutedLink: colors/* GlobalThemeColors.Black */.b.Black,
                breadcrumbTheme: colors/* GlobalThemeColors.Black */.b.Black
            };
        default:
            return {
                dilutedLink: colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice,
                breadcrumbTheme: colors/* GlobalThemeColors.White */.b.White
            };
    }
}
function Footer(param) {
    var className = param.className, columns = param.columns, reassuranceItems = param.reassuranceItems, socialLinks = param.socialLinks, customerService = param.customerService, bottomNav = param.bottomNav, bottomIcons = param.bottomIcons, _withBreadCrumb = param.withBreadCrumb, withBreadCrumb = _withBreadCrumb === void 0 ? true : _withBreadCrumb;
    var t = (0,lib/* useTranslate */.qM)();
    var theme = (0,GlobalDataProvider/* useGlobalData */.U)().theme;
    var footerTheme = theme === null || theme === void 0 ? void 0 : theme.footer;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var computedTheme = getTextColorsFromTheme(footerTheme);
    var reassuranceStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var customerServiceStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta10_12GroteskRegular */.C.Cta10_12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: computedTheme.dilutedLink
    });
    var copyrightStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta10Grotesk */.C.Cta10Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Footer_cx((Footer_styles_module_default()).Footer, className, (Footer_styles_module_default()) === null || (Footer_styles_module_default()) === void 0 ? void 0 : (Footer_styles_module_default())["theme-".concat(footerTheme)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: Footer_cx(gridStyle),
                children: [
                    (reassuranceItems === null || reassuranceItems === void 0 ? void 0 : reassuranceItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_styles_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_styles_module_default()).reassurance,
                                children: reassuranceItems === null || reassuranceItems === void 0 ? void 0 : reassuranceItems.map(function(item, index) {
                                    return (item === null || item === void 0 ? void 0 : item.children) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: (item === null || item === void 0 ? void 0 : item.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                            className: Footer_cx((Footer_styles_module_default()).item, reassuranceStyle),
                                            textPreset: text_preset/* GlobalTextPreset.Cta10GroteskRegular */.C.Cta10GroteskRegular,
                                            textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                            theme: computedTheme.breadcrumbTheme,
                                            lineProps: {
                                                initialLineState: "none"
                                            }
                                        }, item), "reinsurance_item_".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: Footer_cx(reassuranceStyle, (Footer_styles_module_default()).item),
                                            children: item === null || item === void 0 ? void 0 : item.children
                                        }, "reassurance_item_".concat(index))
                                    }, "reassurance_item_".concat(index)) : null;
                                })
                            }),
                            withBreadCrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                                className: (Footer_styles_module_default()).breadcrumb,
                                color: computedTheme.breadcrumbTheme
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_styles_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_styles_module_default()).bodyLeft,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLogo/* default */.Z, {
                                        theme: footerTheme,
                                        className: (Footer_styles_module_default()).logo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Footer_styles_module_default()).columns,
                                        children: (columns === null || columns === void 0 ? void 0 : columns.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: Footer_cx((Footer_styles_module_default()).desktopColumns, (Footer_styles_module_default()).hideOnSmallScreen),
                                                    children: columns === null || columns === void 0 ? void 0 : columns.map(function(column, key) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterColumn, (0,_object_spread/* default */.Z)({
                                                            className: (Footer_styles_module_default()).desktopColumnItem,
                                                            textThemes: computedTheme
                                                        }, column), "column_desktop_".concat(key));
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterMobileColumns, {
                                                    className: Footer_cx((Footer_styles_module_default()).mobileColumns, (Footer_styles_module_default()).hideOnLargeScreen),
                                                    textThemes: computedTheme,
                                                    theme: footerTheme,
                                                    columns: columns
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_styles_module_default()).bodyRight,
                                children: [
                                    socialLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Footer_styles_module_default()).social,
                                        children: socialLinks.map(function(link, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                                textPreset: text_preset/* GlobalTextPreset.Cta10_12GroteskRegular */.C.Cta10_12GroteskRegular,
                                                textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                                theme: computedTheme.dilutedLink,
                                                className: Footer_cx((Footer_styles_module_default()).socialLink),
                                                lineProps: {
                                                    initialLineState: "none"
                                                }
                                            }, link), "link_social_".concat(index));
                                        })
                                    }),
                                    customerService && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                        render: customerService,
                                        className: Footer_cx(customerServiceStyle, (Footer_styles_module_default()).customerService, (Footer_styles_module_default()).hideOnSmallScreen)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Footer_styles_module_default()).bottom,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: gridStyle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_styles_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: Footer_cx((Footer_styles_module_default()).copyright, (Footer_styles_module_default()).hideOnSmallScreen, copyrightStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t(dictionary/* GENERAL.COPYRIGHT */.vh.COPYRIGHT)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "\xa0 -\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://unlikely.technology/",
                                                target: "blank",
                                                children: "tech by Unlikely Technology"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            bottomNav && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: Footer_cx((Footer_styles_module_default()).bottomLinks),
                                children: bottomNav.map(function(link, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                        textPreset: text_preset/* GlobalTextPreset.Cta10GroteskRegular */.C.Cta10GroteskRegular,
                                        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                        theme: colors/* GlobalThemeColors.Gray */.b.Gray,
                                        className: Footer_cx((Footer_styles_module_default()).bottomLink),
                                        lineProps: {
                                            initialLineState: "none"
                                        }
                                    }, link), "link_bottom_".concat(index));
                                })
                            }),
                            bottomIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_styles_module_default()).bottomIcons,
                                children: bottomIcons.map(function(icon, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Footer_styles_module_default()).iconWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icon), {
                                            layout: "fixed",
                                            width: 28,
                                            height: 15,
                                            className: (Footer_styles_module_default()).icon
                                        }))
                                    }, "bottom_icon_".concat(index));
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
Footer.defaultProps = {};
/* harmony default export */ var UI_Footer = (Footer);


/***/ }),

/***/ 11216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__ECBCq","item":"styles_item__bsSPJ"};

/***/ }),

/***/ 15028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__oIqn4","separator":"styles_separator__7OrSY","noLink":"styles_noLink___CVAf","theme-product":"styles_theme-product____PPg","item":"styles_item__HEs7j","active":"styles_active__eYmni","theme-footer":"styles_theme-footer__yoSLo"};

/***/ }),

/***/ 40466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FooterColumn":"styles_FooterColumn__rDfAA","items":"styles_items__Adcdv","link":"styles_link__yI_bc"};

/***/ }),

/***/ 72933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FooterLogo":"styles_FooterLogo__yFiim","logo":"styles_logo__k7op8","theme-amber":"styles_theme-amber__mrQAS"};

/***/ }),

/***/ 59553:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FooterMobileColumns":"styles_FooterMobileColumns__t6_RB","panel":"styles_panel__P61Yf","panelHead":"styles_panelHead___bMrn","panelBody":"styles_panelBody__gEYQ1","item":"styles_item__GnHqY","theme-black":"styles_theme-black__Tr7LL","theme-william":"styles_theme-william__cvVi5","theme-amber":"styles_theme-amber__PecN_","theme-eunry":"styles_theme-eunry__3lDfU","theme-irish-coffee":"styles_theme-irish-coffee__fZX3c"};

/***/ }),

/***/ 50252:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Footer":"styles_Footer__Lt23d","hideOnSmallScreen":"styles_hideOnSmallScreen__Xk9rv","hideOnLargeScreen":"styles_hideOnLargeScreen__A0Bo9","top":"styles_top__ZY3c0","body":"styles_body__qIEPn","reassurance":"styles_reassurance__4vSXe","item":"styles_item__mdoF_","breadcrumb":"styles_breadcrumb__3AK3p","bodyLeft":"styles_bodyLeft__njZjI","bodyRight":"styles_bodyRight__f__g9","logo":"styles_logo__p2eGN","desktopColumnItem":"styles_desktopColumnItem__4zTvg","mobileColumns":"styles_mobileColumns__VqGi9","social":"styles_social__abTwj","customService":"styles_customService__Rc0ZM","socialLink":"styles_socialLink__kGjog","customerService":"styles_customerService__DM9jF","bottom":"styles_bottom__SeU0q","content":"styles_content__QYbxw","copyright":"styles_copyright__55ruX","bottomLinks":"styles_bottomLinks__q6YBM","bottomLink":"styles_bottomLink__6W4Ks","iconWrapper":"styles_iconWrapper__Q7v1W","bottomIcons":"styles_bottomIcons__SkMIk","theme-black":"styles_theme-black__ZSVnd","theme-william":"styles_theme-william__BtCql","theme-eunry":"styles_theme-eunry__yt1wa","theme-irish-coffee":"styles_theme-irish-coffee__hsFs2","theme-amber":"styles_theme-amber__gHD9A"};

/***/ })

}]);